<template>
  <div class="mt-2">
    <div v-if="product">
      <v-layout>
        <v-flex>
          <v-btn flat @click="cancelContent">
            <em class="fas fa-chevron-left mr-1" />
            {{ $t('Back') }}
          </v-btn>
        </v-flex>
        <v-flex class="text-xs-right">
          <v-btn depressed color="primary" @click="saveProduct">{{ $t('Save') }}</v-btn>
        </v-flex>
      </v-layout>

      <h3 class="headline mt-3">{{ $t('Edit Product') }}</h3>

      <div class="pb-3 form-control" :class="{ 'has-error': errors.has('uploadMultipleFile') }">
        <upload-multiple-file
          v-model="productImages"
          :max="1"
          data-vv-name="uploadMultipleFile"
          data-vv-as="Preview Image"
        ></upload-multiple-file>

        <span class="text-error" v-show="errors.has('uploadMultipleFile')">{{
          errors.first('uploadMultipleFile')
        }}</span>
      </div>

      <div class="form-control" :class="{ 'has-error': errors.has('nameInput') }">
        <label class="caption" for="nameInput">{{ $t('Product Name') }} *</label>
        <input
          type="text"
          class="form-control"
          ref="name"
          id="nameInput"
          name="nameInput"
          :data-vv-as="$t('Product Name')"
          aria-describedby="name"
          :placeholder="$t('Product Name')"
          v-model="product.name"
          v-validate="'required'"
        />
        <span class="text-error" v-show="errors.has('nameInput')">{{
          errors.first('nameInput')
        }}</span>
      </div>

      <div class="form-control" :class="{ 'has-error': errors.has('descriptionInput') }">
        <div>
          <label class="caption" for="nameInput">{{ $t('Product detail') }} *</label>
        </div>
        <textarea
          type="text"
          class="form-control"
          id="descriptionInput"
          style="resize: vertical; min-height: 90px; width: 100%"
          name="descriptionInput"
          :data-vv-as="$t('Product detail')"
          aria-describedby="description"
          :placeholder="$t('Product detail')"
          row="3"
          v-model="product.description"
          v-validate="'required'"
        ></textarea>
        <span class="text-error" v-show="errors.has('descriptionInput')">{{
          errors.first('descriptionInput')
        }}</span>
      </div>

      <template v-if="$store.state.specialpage.includes(selectedBot.pageid)">
        <div class="hr" style="margin-top: 35px"></div>
        <template v-if="$store.getters.getPackage == 'premium'">
          <div class="text-xs-center" style="margin-top: -15px">
            <a
              class="btn-advanced"
              href="javascript:void(0);"
              @click="showAdvanced = !showAdvanced"
            >
              {{ $t('Advanced') }}
              <i
                class="fa"
                :class="{ 'fa-angle-down': showAdvanced, 'fa-angle-up': !showAdvanced }"
              />
            </a>
          </div>

          <template v-if="showAdvanced">
            <div class="row form-control" :class="{ 'has-error': errorTag.length > 0 }">
              <div class="col s12">
                <label class="caption" for="keywordInput">{{ $t('Keywords') }}</label>
                <tags
                  v-model="tag"
                  :tags="tags"
                  @tags-changed="(newTags) => (tags = newTags)"
                  @before-adding-tag="checkTag"
                />
                <span class="text-error" v-if="errorTag.length > 0">
                  <template v-if="errorTag.includes('duplicate')">{{
                    $t('Duplicate Choice')
                  }}</template>
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col s12 m6">
                <div
                  class="form-control"
                  v-if="product.buttonaction == 'url' || product.buttonaction == 'buy'"
                >
                  <label class="caption" for="buttonNameInput">{{ $t('Button Name') }}</label>
                  <input
                    type="text"
                    class="form-control"
                    id="buttonNameInput"
                    aria-describedby="Button Name"
                    :placeholder="$t('Button Name')"
                    v-model="product.buttonname"
                  />
                </div>
              </div>
              <div class="col s12 m6">
                <div class="form-control" v-if="product.buttonaction == 'url'">
                  <label class="caption" for="buttonUrlInput">{{ $t('Product Url') }}</label>
                  <input
                    type="text"
                    class="form-control"
                    id="buttonUrlInput"
                    aria-describedby="Product Url"
                    :placeholder="$t('Product Url')"
                    v-model="product.buttonurl"
                  />
                </div>
              </div>
            </div>
          </template>
        </template>
      </template>

      <div class="text-xs-center">
        <v-btn color="grey" outline @click="cancelContent()">{{ $t('cancel') }}</v-btn>
        <v-btn color="primary" depressed @click="saveProduct">{{ $t('Save') }}</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import uploadfile from '@/components/elements/uploadfile'
import api from '@/api'
import VueTagsInput from '@johmun/vue-tags-input'
import UploadMultipleFile from '@/components/elements/UploadMultipleFile'

import Tags from '@/components/elements/Tags'
import { mapGetters } from 'vuex'

export default {
  props: ['value'],
  inject: ['$validator'],
  data: function () {
    return {
      productImages: [],
      product: null,
      tag: '',
      currentView: 'product',
      showAdvanced: false,

      errorTag: []
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    currencySign: function () {
      if (this.product && this.product.currency) {
        switch (this.product.currency.toUpperCase()) {
          case 'THB':
            return '฿'

          default:
            return '$'
        }
      }
      return '$'
    },
    pageid: function () {
      return this.$store.state.selectedBot.pageid
    },
    tags: {
      get() {
        let vm = this
        if (vm.product.keyword != '') {
          var tags = vm.product.keyword.split(',')
          var result = []
          $.each(tags, function (index, val) {
            result.push({ text: val })
          })
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        $.each(value, function (index, val) {
          result.push(val.text)
        })
        vm.product.keyword = result.join(',')
      }
    }
  },
  components: {
    uploadfile: uploadfile,
    VueTagsInput,
    UploadMultipleFile,
    Tags
  },
  mounted: function () {
    let vm = this
    vm.product = JSON.parse(JSON.stringify(vm.value))
    vm.product.buttonaction = 'url'
    vm.cached_product = JSON.stringify(vm.product)

    vm.productstock = []
    $.each(vm.value.productstock, function (index, val) {
      vm.productstock.push(JSON.parse(JSON.stringify(val)))
    })

    vm.cached_productstock = JSON.stringify(vm.value.productstock)

    vm.productImages = vm.product.photourl.split(';;')

    if (vm.productImages.length > 0) {
      vm.productImages.map(function (val, index) {
        if (val == '') {
          vm.productImages.splice(index, 1)
        }
      })
    }
    vm.currentCategory = vm.product.categoryid
    // vm.$refs.name.focus();

    vm.isLoadingBundle = true
    vm.getProductBundle(function (data) {
      vm.productbundle = data
      vm.isLoadingBundle = false
    })

    document.addEventListener('keydown', (e) => {
      if (e.keyCode == 27) {
        vm.$emit('close')
      }
    })
  },
  methods: {
    saveProduct: function () {
      let vm = this

      vm.$validator.validateAll().then((result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()

          return false
        }
        let product = Object.assign({}, vm.product)

        product.currency = 'THB'
        product.categoryid = 0
        product.subcategoryid = 0
        product.buttonname = ''
        product.buttonaction = ''
        product.buttonurl = ''

        product.price = 0
        product.discountprice = 0
        product.pageid = vm.pageid
        product.photourl = vm.productImages.join(';;')

        vm.$store.dispatch('loading')
        api.editProduct(product, function (error, response) {
          vm.completeSaveProduct(product)
        })
      })
    },
    completeSaveProduct: function (product) {
      this.cached_product = JSON.stringify(product)

      this.$emit('input', product)
      this.$emit('onSaveProduct')
    },
    checkTag: function (obj) {
      this.errorTag = []
      if (this.tags.map((t) => t.text).indexOf(obj.tag.text) !== -1) {
        this.errorTag.push('duplicate')
      } else obj.addTag()
    },
    onDeleteProduct: function (id) {
      if (confirm('Do you want to delete this?')) {
        let vm = this
        vm.$store.dispatch('loading')
        api.deleteProduct(id, function (error, response) {
          if (error) {
            vm.$store.dispatch('loading')
            console.error(error)
            return
          }

          vm.$emit('productDeleted')
          vm.$emit('close')
          vm.$store.dispatch('loading')
        })
      }
    },
    cancelContent: function () {
      var vm = this
      vm.product = JSON.parse(vm.cached_product)
      vm.productImages = vm.product.photourl.split(';;')

      vm.$emit('close')
    },
    onChangePoint: function () {
      this.product.discountprice = 0
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      let vm = this
      vm.product = JSON.parse(JSON.stringify(vm.value))
      vm.product.buttonaction = 'url'
      vm.cached_product = JSON.stringify(vm.product)

      vm.cached_productstock = JSON.stringify(vm.value.productstock)
      vm.currentCategory = vm.product.categoryid

      vm.productImages = vm.product.photourl.split(';;')
    }
  }
}
</script>

<style scroped></style>



// WEBPACK FOOTER //
// src/components/view/template/hafele/ModalEditProduct.vue